/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_DescriptionInputs */

const en_home_description = /** @type {(inputs: Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practical U.S. market-entry, business setup coordination, cross-border operations, and professional coordination for founders and companies.`)
};

const pt_home_description = /** @type {(inputs: Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejamento de entrada no mercado dos EUA, coordenação da implantação empresarial, operações transfronteiriças e coordenação profissional para fundadores e empresas.`)
};

const es_home_description = /** @type {(inputs: Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planificación de entrada al mercado de EE. UU., coordinación de la puesta en marcha empresarial, operaciones transfronterizas y coordinación profesional para fundadores y empresas.`)
};

/**
* | output |
* | --- |
* | "Practical U.S. market-entry, business setup coordination, cross-border operations, and professional coordination for founders and companies." |
*
* @param {Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const home_description = /** @type {((inputs?: Home_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_home_description(inputs)
	if (locale === "es") return es_home_description(inputs)
	return en_home_description(inputs)
});